import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, computed  } from 'vue';
import IconAskMark from '@white-label-icon/icon-ask-mark';
import IconSuccess from '@white-label-icon/icon-success';
import { ModalCenter, IconWrapper } from 'ui-shared-components';
import { useRouter } from 'vue-router/composables';

interface ModalErrorProps {
  isSuccess?: boolean,
  isWarning?: boolean,
  isInfo?: boolean,
  propClass?: string,
  btnType?: string,
  closeOnClickOutside?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'modal-error',
  props: {
    isSuccess: { type: Boolean, default: false },
    isWarning: { type: Boolean, default: false },
    isInfo: { type: Boolean, default: false },
    propClass: { default: '' },
    btnType: { default: '' },
    closeOnClickOutside: { type: Boolean, default: false }
  },
  emits: ['close-modal-error'],
  setup(__props: any, { emit }) {

const props = __props as { isSuccess: boolean, isWarning: boolean, isInfo: boolean, propClass: string, btnType: string, closeOnClickOutside: boolean };

;




const router = useRouter();

const IconAlert = defineAsyncComponent(() => import('@white-label-icon/icon-alert'));

const envBasedClassName = computed(() => {
  return `${process.env.NUXT_ENV_THEME}-modal-type-error`;
});

const modalIconsModifiers = computed(() => {
  if (!props.isSuccess) {
        return {
          width: 20,
          height: 20,
        };
      }
      return {};
});

const modalIconType = computed(() => {
  if (props.isWarning) {
        return 'warning';
      }
  if (props.isInfo) {
    return 'info';
  }
  if (props.isSuccess) {
    return 'success';
  }
  return 'error';
});

const modalTypeLabel = computed(() => {
  if (props.isSuccess) return 'Success';
  if (props.isWarning) return 'Warning';
  if (props.isInfo) return 'Information';
  return 'Error';
});

const closeModal = (): void => {
  emit('close-modal-error');
};

const reloadPage = (): void => {
  router.go(0);
};


return { __sfc: true,props, emit, router, IconAlert, envBasedClassName, modalIconsModifiers, modalIconType, modalTypeLabel, closeModal, reloadPage, IconAskMark, IconSuccess, ModalCenter, IconWrapper }
}

})